module.exports = __webpack_public_path__ + "img/PS30.3fb3bf5f.png";